import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './components/HomePage.vue';

const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: HomePage,
    },
    {
        path: '/:taxonomy',
        name: 'Taxonomy',
        component: HomePage,
    }
]
export const router = createRouter({
    history: createWebHistory(window.location.pathname),
    routes,
});
